module.exports = __webpack_public_path__ + "img/icon-hh.0677d172.png";